import API from '../api'

const userService = {}

userService.login = async function (usuario) {
  return API.post('/Token/Login', {}, {
    auth: {
      username:usuario.name,
      password:usuario.password
    }
  })
  
}

userService.error = async function (statusCode) {
  return API.get(`/Admin/error/${statusCode}`, {
  }).then(res => res.data)
}
userService.getDataToken = function(paccess_token){
  let access_token = paccess_token||localStorage.getItem('access_token')
  let sucursal = JSON.parse(window.atob(access_token.split('.')[1]))
  return{
    cliente: JSON.parse(sucursal.Cliente),
    nombre: sucursal.Nombre,
    numSuc: sucursal.NumSuc,
    role: sucursal.role,
    usuario: sucursal.unique_name,
    refresh: sucursal.tokenRefresh,
    exp: sucursal.exp // <-- agrega esto
  }
}
userService.refreshToken = async function () {
  const currentToken = localStorage.getItem('access_token')
  if (!currentToken) throw new Error('No hay token para renovar')

  const payload = JSON.parse(window.atob(currentToken.split('.')[1]))
  const username = payload.unique_name
  const refresh = payload.tokenRefresh

  try {
    const response = await API.post('/Token/refresh', { refresh, username })
    const newToken = response.data.access_token

    const newUserData = userService.getDataToken(newToken)
    localStorage.access_token = newToken
    localStorage.userReprod = JSON.stringify(newUserData)

    return newToken
  } catch (error) {
    // 400 = el backend determinó que ESE refresh puntual es inválido,
    // ya usado, expirado o la sesión fue cerrada: es un error terminal,
    // reintentar con el mismo refresh nunca va a funcionar.
    // Cualquier otro caso (sin respuesta, timeout, 5xx) se trata como
    // transitorio y sí vale la pena reintentar.
    const isTerminal = !!(error.response && error.response.status === 400)
    const message = error.response?.data || error.message || 'Error al renovar el token'
    const err = new Error(message)
    err.isTerminal = isTerminal
    throw err
  }
}

userService.logout = async function () {
  const refresh = userService.current().tokenRefresh
  const username = userService.current().unique_name
  
  return API.put('/Token/Logout', {
    refresh, username
  }).then(res => localStorage.clear())
  
}

userService.current = function () {
  return JSON.parse(localStorage.userReprod)
}

userService.valirdarToken = function () {
  const user = userService.current()
  const exp = Number(user.exp) * 1000 // JWT exp es en segundos, JS Date en ms
  var fecha = Date.now()
  if (fecha > exp) {
    return false
  }
  return true
}

userService.autenticado = function () {
  if (localStorage.user && userService.valirdarToken()) {
    return true
  }
  userService.logout()
  return false
}

// userService.IsAdmin = function() {
//     let Cliente = JSON.parse(userService.current().Cliente);
//     if (Cliente !== null && typeof Cliente === 'object') {
//         return false;
//     }
//     return true;
// }

// userService.CambiarPass = async function(passAnterior, passNueva, passRepetir) {
//     return API.post('/Usuario/CambiarPass', { passAnterior, passNueva, passRepetir }).then(res => res.data);
// }

export default userService